import { useGateValue } from '@statsig/react-bindings';
import { useEffect, useRef } from 'react';
import { reportIfFramed } from 'util/frame-detection';

// Kill switch for frame-detection reports: turning this gate off in Statsig
// stops them for everyone. A missing gate evaluates to off. See sc-370021.
export const FRAME_DETECTION_GATE = 'web-frame-ancestor-reporting';

const FrameDetection = ({ children }) => {
  const isEnabled = useGateValue(FRAME_DETECTION_GATE);
  const hasReportedRef = useRef(false);

  useEffect(() => {
    if (!isEnabled || hasReportedRef.current) return;
    hasReportedRef.current = true;
    reportIfFramed().catch(() => {});
  }, [isEnabled]);

  return children;
};

export default FrameDetection;
